import { useEffect, useState } from "react";
import { Card, CardHeader, CardBody } from "../../design-system/Card";
import { Button } from "../../design-system/Button";
import { Badge } from "../../design-system/Badge";
import { Icon } from "../../design-system/Icon";
import { fetchAlertsConfig, saveAlertsConfig, sendAlertsTest, type AlertsConfig } from "../../ipc/http-transport";

/**
 * Alertas por correo (Fase M7). Solo en la versión web/nube: el servidor revisa la Vigilancia cada
 * 12 h y envía por correo (Gmail) las oportunidades nuevas. Requiere una "contraseña de aplicación"
 * de Gmail (no la contraseña normal).
 */
export function AlertsPanel(): JSX.Element {
  const [cfg, setCfg] = useState<AlertsConfig | null>(null);
  const [user, setUser] = useState("");
  const [to, setTo] = useState("");
  const [pass, setPass] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  useEffect(() => { void fetchAlertsConfig().then((c) => { if (c) { setCfg(c); setUser(c.user); setTo(c.to); } }); }, []);

  const save = async (enabled: boolean): Promise<void> => {
    setBusy(true); setMsg(null);
    const c = await saveAlertsConfig({ enabled, user: user.trim(), to: to.trim(), ...(pass.trim() ? { pass: pass.trim() } : {}) });
    setBusy(false);
    if (c) { setCfg(c); setPass(""); setMsg("Configuración guardada."); } else setMsg("No se pudo guardar.");
  };
  const test = async (): Promise<void> => {
    setBusy(true); setMsg(null);
    const r = await sendAlertsTest();
    setBusy(false); setMsg(r.detail);
  };

  return (
    <Card style={{ marginTop: "var(--sp-5)" }}>
      <CardHeader
        title={<span className="row" style={{ gap: 8 }}><Icon name="bell" size={18} /> Alertas por correo</span>}
        subtitle="El servidor revisa tu Vigilancia cada 12 h y te envía por correo las oportunidades nuevas — sin abrir la app."
        action={cfg ? <Badge tone={cfg.enabled ? "success" : "neutral"} dot>{cfg.enabled ? "Activas" : "Desactivadas"}</Badge> : null}
      />
      <CardBody>
        <div style={{ display: "grid", gap: "var(--sp-3)", maxWidth: 460 }}>
          {msg ? <div className="callout"><div className="bar" /><div className="body">{msg}</div></div> : null}
          <label className="pd-field"><span className="pd-field__label">Tu Gmail (remitente)</span>
            <input className="pd-input" type="email" placeholder="tucorreo@gmail.com" value={user} onChange={(e) => setUser(e.target.value)} /></label>
          <label className="pd-field"><span className="pd-field__label">Contraseña de aplicación de Gmail (16 caracteres){cfg?.configured ? " — deja vacío para no cambiarla" : ""}</span>
            <input className="pd-input" type="password" placeholder="xxxx xxxx xxxx xxxx" value={pass} onChange={(e) => setPass(e.target.value)} /></label>
          <label className="pd-field"><span className="pd-field__label">Enviar las alertas a</span>
            <input className="pd-input" type="email" placeholder="tucorreo@gmail.com" value={to} onChange={(e) => setTo(e.target.value)} /></label>
          <div className="row" style={{ gap: "var(--sp-2)", flexWrap: "wrap" }}>
            <Button icon="check" disabled={busy || !user.trim() || !to.trim()} onClick={() => save(true)}>{busy ? "Guardando…" : "Guardar y activar"}</Button>
            <Button variant="secondary" disabled={busy} onClick={() => save(false)}>Desactivar</Button>
            <Button variant="ghost" icon="pulse" disabled={busy || !cfg?.configured} onClick={test}>Enviar correo de prueba</Button>
          </div>
          <div className="faint" style={{ fontSize: 12 }}>
            ¿Cómo obtener la contraseña de aplicación? En tu cuenta Google: activa la <b className="strong">Verificación en 2 pasos</b>, luego ve a <b className="strong">myaccount.google.com/apppasswords</b>, crea una para "FABIAN-MELI" y pega aquí los 16 caracteres.
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
